import * as auto_pi from "@crochik/auto-pi";

export const DraggableItemTypes = {
    ROW: "row",
    FIELD: "field",
};

export interface Row {
    fields: auto_pi.Field[];
}
